import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    // 首页
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: '首页', icon: 'el-icon-news', affix: true }
      }
    ]
  },
  {
    // 登录页
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
// export const asyncRoutes = [
//   // 运营管理
//   {
//     path: "/operate",
//     component: Layout,
//     redirect: "/",
//     name: "运营管理",
//     meta: { title: "运营管理", icon: "el-icon-setting" },
//     children: [
//       {
//         // 微信用户管理
//         path: "/operate/wxUser",
//         component: () => import("@/views/operate/wxUser"),
//         name: "Management",
//         meta: {
//           title: "微信用户管理",
//           roles: ["admin:admin"],
//           icon: "icon-guanliyuan",
//           info: "微信用户管理",
//         },
//       },
//       {
//         // banner管理
//         path: "/operate/bannerOperate",
//         component: () => import("@/views/operate/bannerOperate"),
//         name: "globalNewParams",
//         meta: {
//           title: "banner管理",
//           roles: ["admin:systemConfig"],
//           icon: "icon-quanju_yuming",
//           info: "平台新全局参数设置",
//         },
//       },
//       {
//         // 项目管理
//         path: "/operate/project",
//         component: () => import("@/views/operate/project"),
//         name: "GlobalText",
//         meta: {
//           title: "项目管理",
//           roles: ["admin:systemContent"],
//           icon: "icon-tongyong",
//           info: "注册协议、关于我们、隐私政策",
//         },
//       },
//       {
//         // 问卷管理
//         path: "/operate/questionnaire",
//         component: () => import("@/views/operate/questionnaire"),
//         name: "GlobalText",
//         meta: {
//           title: "问卷管理",
//           roles: ["admin:systemContent"],
//           icon: "icon-tongyong",
//           info: "注册协议、关于我们、隐私政策",
//         },
//       },
//       {
//         // 答卷记录
//         path: "/operate/record",
//         component: () => import("@/views/operate/record"),
//         name: "GlobalText",
//         meta: {
//           title: "答卷记录",
//           roles: ["admin:systemContent"],
//           icon: "icon-tongyong",
//           info: "注册协议、关于我们、隐私政策",
//         },
//       },
//     ],
//   },
//   // 系统设置
//   {
//     path: "/setting",
//     component: Layout,
//     redirect: "/",
//     name: "系统设置",
//     meta: { title: "系统设置", icon: "el-icon-setting" },
//     children: [
//       {
//         // 管理员管理
//         path: "/setting/manangement",
//         component: () => import("@/views/setting/management"),
//         name: "Management",
//         meta: {
//           title: "管理员管理",
//           roles: ["admin:admin"],
//           icon: "icon-guanliyuan",
//           info: "后台管理员管理",
//         },
//       },
//       {
//         // 角色分配
//         path: "/setting/roleManagement",
//         component: () => import("@/views/setting/roleManagement"),
//         name: "RoleManagement",
//         meta: {
//           title: "角色分配",
//           roles: ["admin:role"],
//           icon: "icon-jiaosequanxian",
//           info: "角色分配管理",
//         },
//       },
//       {
//         // 新全局参数
//         path: "/setting/globalNewParams",
//         component: () => import("@/views/setting/globalNewParams"),
//         name: "globalNewParams",
//         meta: {
//           title: "新全局参数",
//           roles: ["admin:systemConfig"],
//           icon: "icon-quanju_yuming",
//           info: "平台新全局参数设置",
//         },
//       },
//       {
//         // 通用内容
//         path: "/setting/globalText",
//         component: () => import("@/views/setting/globalText"),
//         name: "GlobalText",
//         meta: {
//           title: "通用内容",
//           roles: ["admin:systemContent"],
//           icon: "icon-tongyong",
//           info: "注册协议、关于我们、隐私政策",
//         },
//       },
//     ],
//   },
// ];

const createRouter = () =>
  new Router({
    mode: 'hash', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
